module.exports = __webpack_public_path__ + "img/play.809b4f7a.svg";